export async function GetTokenSession(
  transactionId,
  {
    requestSource = "ECOMMERCE",
    merchantCode = process.env.REACT_APP_IZIPAY_MERCHANT_CODE || "4004353",
    orderNumber = "21",
    publicKey = process.env.REACT_APP_IZIPAY_PUBLIC_KEY ||
      "VErethUtraQuxas57wuMuquprADrAHAb",
    amount = "30",
    currency = "PEN",
  },
) {
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
  const response = await fetch(`${API_URL}/api/payments/izipay/session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      transactionId: transactionId,
    },
    body: JSON.stringify({
      requestSource,
      merchantCode,
      orderNumber,
      publicKey,
      amount: Number(amount).toFixed(2),
      currency,
    }),
  });
  return await response.json();
}
